import { ReactNode } from 'react';
import { Divider, useTheme } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { ReactComponent as TrashIcon } from '../../../design-system/Icons/Trash.svg';
import DSBox from '../../../design-system/DSBox';
import { DSTypography } from '../../../design-system/Typography';
import DSIconButton from '../../../design-system/DSIconButton';

type SectionEditorCardProps = {
  title: string;
  onDelete: () => void;
  children: ReactNode;
  isDragActive?: boolean;
};

const SectionEditorCard = ({
  title,
  onDelete,
  children,
  isDragActive,
}: SectionEditorCardProps) => {
  const { spacing } = useTheme();

  return (
    <DSBox
      sx={{
        borderRadius: spacing(2),
        overflow: 'hidden',
        backgroundColor: 'paper.elevation2',
        py: spacing(3),
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(3),
      }}
    >
      <DSBox sx={{ display: 'flex', flexDirection: 'column', gap: spacing(2) }}>
        <DSBox
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: spacing(3),
          }}
        >
          <DSBox
            sx={{ display: 'flex', alignItems: 'center', gap: spacing(1.5) }}
          >
            <DragIndicatorIcon sx={{ color: 'action.active', fontSize: 24 }} />
            <DSTypography variant="subtitle1">{title}</DSTypography>
          </DSBox>
          <DSIconButton
            onClick={onDelete}
            size="small"
            sx={{ color: 'action.active' }}
          >
            <TrashIcon width={20} height={20} />
          </DSIconButton>
        </DSBox>
        <Divider sx={{ borderColor: 'white.12' }} />
      </DSBox>
      <DSBox
        sx={{
          px: spacing(3),
          ...(isDragActive && { pointerEvents: 'none' }),
        }}
      >
        {children}
      </DSBox>
    </DSBox>
  );
};

export default SectionEditorCard;
